<div class="access-container">
  <!-- Loading state -->
  <div *ngIf="isLoading" class="loading-state">
    <loading message="Loading authentication status..."></loading>
  </div>

  <!-- Error state -->
  <div *ngIf="hasError && !isLoading" class="error-state">
    <div class="error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    <div class="error-message">Failed to load authentication status</div>
    <button class="btn btn-primary" data-testid="btn-auth-status-retry" (click)="loadAuthStatus()">Try Again</button>
  </div>

  <!-- Auth status content -->
  <div *ngIf="!isLoading && !hasError && authStatus" class="auth-status-content">
    <div class="account-card">
      <h2>Authentication Status</h2>
      
      <!-- Progress chart -->
      <div class="auth-progress-container">
        <div class="auth-progress-chart">
          <div class="progress-steps">
            <div *ngFor="let step of steps; let i = index" class="progress-step">
              <div class="step-circle" [class.completed]="isStepCompleted(step.id)">
                <div class="inner-circle" *ngIf="isStepCompleted(step.id)"></div>
              </div>
              <div class="step-label">{{ step.label }}</div>
              
              <!-- Connector line between circles (except for the last one) -->
              <div *ngIf="i < steps.length - 1" class="connector-line" 
                   [class.completed]="isStepCompleted(step.id) && isStepCompleted(steps[i+1].id)">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional auth details -->
      <div class="auth-details">
        <div class="detail-row">
          <div class="detail-label">Created By:</div>
          <div class="detail-value">
            <ng-container *ngIf="userRoleService.isManagerOrAdmin() && authStatus.created_by_id">
              <a [routerLink]="['/users/application/user', authStatus.created_by_id]"
                class="link">
                {{ authStatus.created_by || 'N/A' }}
              </a>
            </ng-container>
            <ng-container *ngIf="!userRoleService.isManagerOrAdmin() || !authStatus.created_by_id">
              {{ authStatus.created_by || 'N/A' }}
            </ng-container>
          </div>
          <!-- Creator ID =  authStatus.created_by_id  -->
        </div>
        <div class="detail-row">
          <div class="detail-label">Last Login:</div>
          <div class="detail-value">{{ formatDate(authStatus.last_login) }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- No data state -->
  <div *ngIf="!isLoading && !hasError && !authStatus" class="no-data-state">
    <p>No authentication data available for this user.</p>
  </div>

  <!-- Resend invitation section (shown when the user has not logged in / no COGNITO_ID) -->
  <div *ngIf="!isLoading && !hasError && user && !user.COGNITO_ID" class="resend-invite-section">
    <div class="account-card">
      <p class="margin-bottom-20">User has not logged in yet. Resend invitation email?</p>
      <button class="btn btn-primary" data-testid="btn-resend-invitation" (click)="resendInvitation()" [disabled]="resending">
        <span *ngIf="!resending">Resend Invitation</span>
        <span *ngIf="resending">Resending...</span>
      </button>
    </div>
  </div>
</div>
